import { CurrentProductInfo } from "@redotech/redo-model/concierge-conversation/rpc/concierge-conversation-schema";
import {
  isOnProductPage,
  shopifyProductHandle,
} from "@redotech/redo-shopify-extension/shopify";
import { UseQueryResult } from "@tanstack/react-query";
import { ReactNode, createContext, memo, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useCurrentProductInfo } from "../hooks/use-current-product-info";

// Utility to extract Shopify product handle from URL if on product page
const maybeGetShopifyProductHandle = (url: string, onTapcart?: boolean) => {
  if (isOnProductPage(onTapcart)) {
    return shopifyProductHandle(url);
  }
  return null;
};

export const CurrentProductInfoQueryContext = createContext<
  UseQueryResult<CurrentProductInfo, Error> | undefined
>(undefined);

export const CurrentProductInfoQueryProvider = memo(
  function CurrentProductInfoQueryProvider({
    children,
  }: {
    children: ReactNode | ReactNode[];
  }) {
    const [productHandle, setProductHandle] = useState<string | null>(null);
    const location = useLocation();
    useEffect(() => {
      const newProductHandle = maybeGetShopifyProductHandle(
        window.location.href,
        !!(globalThis as any).Tapcart && !(globalThis as any).Shopify,
      );
      setProductHandle(newProductHandle);
    }, [location.pathname]);

    const currentProductInfoQuery = useCurrentProductInfo(productHandle);
    return (
      <CurrentProductInfoQueryContext.Provider value={currentProductInfoQuery}>
        {children}
      </CurrentProductInfoQueryContext.Provider>
    );
  },
);
